import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import { useResolveRequestHook } from '@/modules/shared/hooks/use-resolve-request.hook'
import { useMainStore } from '@/modules/shared/stores/main.store'

import { useTransmitOrderMutation } from '../mutations/transmit-order.mutation'
import { useFetchOrdersTransmissionQuery } from '../querys/get-orders-transmission.query'
import type { Order } from '../types/order.type'

export const useOrderTransmission = () => {
  const [orderSelected, setOrderSelected] = useState<string[]>([])

  const queryClient = useQueryClient()

  const navigate = useNavigate()
  const { orders, isLoadingOrdersTransmission } =
    useFetchOrdersTransmissionQuery()

  const handleSubmitOrderTransmissionCallback = async () => {

    const cached = queryClient.getQueryData<Order[]>([QUERY_KEYS.ORDERS])

    const updated = cached?.map((order) => {
      if (orderSelected.includes(order.idPedido.toString())) {
        return {
          ...order,
          fkStatus: '9',
          status: 'Importado',
          statusImg: 'MdFactory',
          statusSigla: 'TR',
        }
      }

      return order
    })

    queryClient.setQueryData([QUERY_KEYS.ORDERS], updated)

    setOrderSelected([])

    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.GOALS_REPORTS],
    })
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.CLIENTS_REPORTS],
    })
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.ORDERS_FILTERED],
    })
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.ORDER_TRANSMISSION],
    })
  }

  const { checkStatusOnRequest } = useResolveRequestHook()

  const {
    mutateAsync: transmitOrderRequest,
    isLoading: isLoadingOrderRequest,
  } = useTransmitOrderMutation({
    callback: handleSubmitOrderTransmissionCallback,
    resolveRequest: checkStatusOnRequest,
  })

  const { setConfirmation, setCloseConfirmation } = useMainStore().actions

  const handleBackPage = () => {
    navigate('/')
  }

  const handleSelectAll = () => {
    const allOrderIds = orders.map(item => item.idPedidoCel.toString())
    setOrderSelected(allOrderIds)
  }

	const handleRemoveAll = () => {
		setOrderSelected([])
	}

  const handleSelectOrRemoveOrderOfArray = (orderId: string) => {
    setOrderSelected((prev) => {
      const index = prev.indexOf(orderId)

      if (index !== -1) {
        return prev.filter((order) => order !== orderId)
      }

      return [...prev, orderId]
    })
  }

  const handleSubmitOrderTransmission = () => {

    if (orderSelected.length === 0) {
      toast.info('Selecione um pedido para transmitir')
      return
    }
    setConfirmation({
      title: 'Confirmação',
      message: 'Deseja transmitir o(s) pedido(s) selecionado(s)?',
      isOpen: true,
      onClose: () => {
        setCloseConfirmation()
      },
      onConfirm: () => {
        transmitOrderRequest({
          payload: {
            orderId: orderSelected,
          },
        })
        setCloseConfirmation()
      },
    })
  }

  return {
    orders,
    orderSelected,
    isLoading: isLoadingOrderRequest || isLoadingOrdersTransmission,
    handleBackPage,
    handleSubmitOrderTransmission,
    handleSelectOrRemoveOrderOfArray,
		handleSelectAll,
		handleRemoveAll
  }
}
